/* ClientPage auto-generated by npm run generator */
import { CircularProgress, makeStyles, Theme, Typography } from "@material-ui/core"
import { PortalHeader } from "components/atoms/PortalHeader"
import ClientCharts from "components/molecules/charts/ClientCharts"
import ClientCards from "components/molecules/ClientCards"
import ClientTable from "components/molecules/ClientTable"
import ClientMenu from "components/molecules/dropdowns/ClientMenu"
import { useDocSubscribe } from "hooks/useSnapshots"
import { observer } from "mobx-react"
import React from "react"
import { useParams } from "react-router-dom"
import Store from "store/Store"

interface ClientPageProps {}

const useStyles = makeStyles((theme: Theme) => ({
    clientPagePage: {
        display: "grid",
        gridGap: theme.spacing(8),
    },
}))

const ClientPage: React.FC<ClientPageProps> = (props) => {
    const classes = useStyles()
    const { clientCaseId, clinicianId } = useParams()

    // const [client, setClient] = React.useState<Client | undefined>()

    // React.useEffect(() => .onSnapshot((user) => setClient(user.data())), [clientCaseId])
    const client = useDocSubscribe(Store.auth.clientCollection.doc(clientCaseId))
    const clinician = useDocSubscribe(Store.auth.clinicianCollection.doc(clinicianId))
    if (!clientCaseId) {
        return <div>Client not found</div>
    }

    if (!client || !clinician) {
        return <CircularProgress />
    }

    return (
        <div className={classes.clientPagePage}>
            <PortalHeader>
                <Typography variant="h5">Client: {client.displayName}</Typography>
                <ClientMenu client={client} clinician={clinician} />
            </PortalHeader>
            <ClientCards client={client} />
            <ClientCharts client={client} />
            <ClientTable client={client} />
        </div>
    )
}

export default observer(ClientPage)
